function hasClass(e, className) {
  if (e.classList) {
    return e.classList.contains(className);
  }
  return !!e.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)')); // eslint-disable-line
}

function addClass(e, className) {
  if (e.classList) {
    e.classList.add(className);
  } else if (!hasClass(e, className)) {
    e.className = e.className ? `${e.className} ${className}` : className;
  }
}

function removeClass(e, className) {
  if (e.classList) {
    e.classList.remove(className);
  } else if (hasClass(e, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)'); // eslint-disable-line
    e.className = e.className.replace(reg, ' ');
  }
}

function sameTagname(tag1, tag2) {
  return tag1.toUpperCase() === tag2.toUpperCase();
}

function getFirstChild(parentElt, tagname) {
  const children = parentElt.childNodes;
  const match = Array.isArray(tagname)
    ? tag => tagname.find(t => sameTagname(tag, t))
    : tag => sameTagname(tag, tagname);
  for (let i = 0; i < children.length; i += 1) {
    const child = children[i];
    if (child.nodeType === Node.ELEMENT_NODE) {
      if (!tagname || match(child.tagName)) {
        return child;
      }
    }
  }
  return undefined;
}

function getText(elt) {
  const txt = elt.textContent;
  return txt.replace(/(^\s+|\s+$)/g, '');
}

function offsetCoordinates(e, ancestorRef) {
  // const r = e.getBoundingClientRect();
  // const ra = ancestorRef.getBoundingClientRect();
  // return { left: r.left - ra.left + ancestorRef.scrollLeft, top: r.top - ra.top + ancestorRef.scrollTop };
  let z = e;
  let x = 0;
  let y = 0;
  let c;
  while (z) {
    c = window.getComputedStyle(z, null);
    x += z.offsetLeft + (c ? parseInt(c.getPropertyValue('border-left-width'), 10) : 0);
    y += z.offsetTop + (c ? parseInt(c.getPropertyValue('border-top-width'), 10) : 0);
    z = z.offsetParent;
  }
  if (ancestorRef) {
    const aCoord = offsetCoordinates(ancestorRef);
    return { left: x - aCoord.left, top: y - aCoord.top };
  }
  return { left: x, top: y };
}

export { hasClass, addClass, removeClass, sameTagname, getFirstChild, getText, offsetCoordinates };
